import { Icon } from '@toggle/design-system';
import { CatalystInsight, CatalystInsightCategory } from '@toggle/toggle';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { PosthogTrackingSource } from '~/services/tracking/posthog/constants';
import { getCatalystInsightIconProps } from '~/widgets/catalyst-insights-drawer/catalyst-insight-icon/utils';
import { useCatalystDrawer } from '~/widgets/catalyst-insights-drawer/useCatalystDrawer';

import * as S from './ClickableCatalystInsightTooltip.styles';

interface ClickableCatalystInsightTooltipProps {
  insights: CatalystInsight[];
  category: CatalystInsightCategory;
  source: PosthogTrackingSource;
}

export const ClickableCatalystInsightTooltip = ({
  insights,
  category,
  source,
}: ClickableCatalystInsightTooltipProps) => {
  const { t } = useTranslation(['insights']);
  const { openDrawer } = useCatalystDrawer();

  const isCompanyCatalyst = category === 'company';
  const iconProps = getCatalystInsightIconProps({
    isBordered: true,
    isCompanyCatalyst,
  });
  return (
    <>
      {insights.map(insight => (
        <S.TooltipWrapper
          key={insight.id}
          onClick={() =>
            // TODO refactor hardcoded value once we introduce the market catalysts
            openDrawer({
              type: 'company',
              entityTag: insight.identifier as string,
              insightId: insight.id,
              source,
            })
          }
        >
          <Icon {...iconProps} size={32} />
          <S.RightWrapper>
            <S.TooltipTitleLabel>
              {isCompanyCatalyst
                ? t('insights:catalyst.titleCompanyCatalyst')
                : t('insights:catalyst.titleMarketCatalyst')}
            </S.TooltipTitleLabel>
            <S.CategoryLabel>
              {/* i18next-extract-mark-context-next-line ["financial_operational_updates", "corporate_actions_strategic_announcements", "management_leadership_changes", "legal_regulatory_events"] */}
              {t(`catalyst.subcategories.${insight.sub_category}`)}
            </S.CategoryLabel>
          </S.RightWrapper>
        </S.TooltipWrapper>
      ))}
    </>
  );
};
